import UserModel from '@/models/user';

export const mockUser: UserModel = {
  username: 'mock.user',
  userId: '1000000001',
  preferredUsername: 'mock.user',
  name: 'مستخدم تجريبي',
  givenName: 'محمد',
  surName: 'العلي',
  middleName: 'أحمد',
  grandFatherName: 'سعيد',
  email: 'mock.user@example.com',
  gender: '1',
  birthDateHijri: '1410-01-15',
  birthDate: '1989-08-16',
  age: '36',
  nationalityName: 'سعودي',
};

export function mockBillSuccess(invoiceNumber: string, paymentPercentage = 65) {
  return {
    GetBillInformationPublicResponse: {
      GetBillInformationPublicResult: {
        BillingNumber: Number(invoiceNumber) || 123456789012345,
        CaseDescription: 'فاتورة تجريبية — سداد جزئي لرسوم تنفيذ حكم قضائي (بيانات وهمية للتطوير المحلي).',
        criteria: 1,
        PaymentPercentage: paymentPercentage,
        RemainingAmount: 3500.5,
        samisID: 99887766,
      },
    },
  };
}

export function mockBillFullyPaid(invoiceNumber: string) {
  return mockBillSuccess(invoiceNumber, 100);
}

export const mockBillError = {
  Fault: {
    faultstring: {
      TEXT: 'رقم الفاتورة غير صحيح أو غير موجود (استجابة وهمية).',
    },
  },
};
